<c-container class="mt-5">
  <h2>Causable Admin Reporting</h2>

  @if (isCrossGame) {
    <app-choose-your-game (gameChosenEvent)="onGameChange($event)"></app-choose-your-game>
  }

  @if (game) {
    <app-reports [gameSetter]="game"></app-reports>
  }
</c-container>
